import Vue from 'vue'
import Router from 'vue-router'
import index from '@/views/new-index'
import notice from '@/views/notice.vue'//工告
import tourGL from '@/views/tourStrategy.vue'//景区攻略
import tourZL from '@/views/tourAll.vue'//景区总览
// import tourLX from '@/views/tourLineRoad.vue'//景区路线
import tourKF from '@/views/tourKefu.vue'//客服
import tourHD from '@/views/tourActivity.vue'//景区活动
import tourMessage from '@/views/tourMessage.vue'//景区攻略详情
import zhinan from '@/views/zhinan.vue'//指南
import zhongzhuan from "@/views/zhongzhuan.vue"
import * as config from "@/api/api";

Vue.use(Router)

export default new Router({
  routes: [
    {
      path: '/',
      name: 'Index',
      component: index,
      beforeEnter(to, from, next) {
        config.addExplanatio().then(res=>{
      console.log(res,']]]]]]]]]]]]]]]')
      let txMapKey = res.data.data.tx_map_key
      if(res.data.data.tx_map_key){
        localStorage.setItem("tx_map_key",res.data.data.tx_map_key)
        txMapKey = res.data.data.tx_map_key
      }else{
        txMapKey = 'BN6BZ-URCWF-3NTJD-N6J24-YTMS2-IPBZM'
      }
          
    const script = document.createElement("script");
            script.id = "tencent-map-gljs";
            script.type = "text/javascript";
            // 拼接API地址，callback指定全局函数名
            script.src = `https://map.qq.com/api/gljs?v=2.exp&key=${res.data.data.tx_map_key}&referer=audioApp&callback=initTMap`;
          var script2 = document.createElement('script');
          // script2.charset = 'utf-8';
          script2.src = `https://map.qq.com/api/gljs?v=1.exp&key=${res.data.data.tx_map_key}&libraries=geometry&callback=initTMap1`;
        var script1 = document.createElement('script');
        script1.type = 'text/javascript';
        script1.src = `https://apis.map.qq.com/tools/geolocation/min?key=${res.data.data.tx_map_key}&referer=audioApp`;
        document.head.appendChild(script);
        document.head.appendChild(script1);
        document.head.appendChild(script2);
        script.onload = () => {
          console.log("腾讯地图JS加载完成");

        };
        script1.onload = () => {
          console.log("腾讯地图JS加载完成1");
        };
        script2.onload = () => {
          console.log("腾讯地图JS加载完成2");
        };
           window.initTMap = () => {
           window.initTMap1 = () => {
             next()
            }
          };
    })
      }
    },
    {
      path: '/notice',
      name: 'notice',
      component: notice
    },
    {
      path: '/tourGL',
      name: 'tourGL',
      component: tourGL
    },{
      path: '/tourZL',
      name: 'tourZL',
      component: tourZL
    },{
      path: '/tourKF',
      name: 'tourKF',
      component: tourKF
    },
    {
      path: '/tourHD',
      name: 'tourHD',
      component: tourHD
    },
    {
      path: '/tourMessage',
      name: 'tourMessage',
      component: tourMessage
    },
    {
      path: '/zhinan',
      name: 'zhinan',
      component: zhinan
    },
    {
      path: '/zhongzhuan',
      name: 'zhongzhuan',
      component: zhongzhuan
    }
  ]
})



// WEBPACK FOOTER //
// ./src/router/index.js